import Vue from 'vue'
import store from './@store'
import {mapState, mapActions} from 'vuex'
import select from 'select-dom'
import debounce from 'lodash/debounce'
import '../picture/picture.vue'
import '../plp-select/plp-select.vue'
import '../pagination/pagination.vue'

export default el => new Vue({
  name: 'PLP',
  el,
  store: store(),
  data () {
    return {
      settings: () => ({}),
      calloutBreakpoints: '(max-width: 767px)|(min-width: 768px)',
      productsPerPage: 12,
      plpCalloutJson: window.BARREL.plpCalloutJson || []
    }
  },
  watch: {
    'compactView' (value) {
      if (!value) {
        this.$nextTick(debounce(() => {
          const cardItem = select.all('.plp__grid-item--normal')
          if (cardItem && cardItem[16]) {
            const focusEl = select('a', cardItem[16])
            focusEl.focus({preventScroll: false})
          }
        }, 500))
      }
    }
  },
  mounted () {
    let initial = el.getAttribute('data-initial')
    let decodedImport = decodeURIComponent(initial)
    let collection = JSON.parse(decodedImport)
    this.$store.state.collection = collection
    this.fetchCollectionHeroSettings()
    this.fetchCollection({
      handle: location.pathname,
      ajaxing: false,
      initial: true
    })

    const productsPerPage = el.getAttribute('data-products-per-page')
    if (productsPerPage) {
      this.productsPerPage = parseInt(productsPerPage)
    }

    window.dataLayer.push({
      event: 'collectionView',
      collectionName: collection.title,
    })
  },
  computed: {
    ...mapState([
      'collection',
      'products',
      'mounted',
      'ajaxing',
      'loading',
      'selectedFacets',
      'sort',
      'compactView',
      'isMobile',
      'currentPage'
    ]),
    ...mapState({
      visibleProducts (state) {
        const statePorduts = [...state.products, ...this.plpCallout]
        const listItems = (statePorduts || []).filter(p => this.shouldShowProduct(p))
        let listTypeProduct = listItems.filter(p => p.type === 'product')
        let calloutItems = listItems.filter(p => p.type !== 'product' && !p.isHide).sort((a, b) => a.position - b.position)

        const insert = (arr, index, newItem) => [
          ...arr.slice(0, index),
          newItem,
          ...arr.slice(index)
        ]

        calloutItems.forEach(p => {
          listTypeProduct = insert(listTypeProduct, p.position, p)
        })

        return listTypeProduct
      },
      paginatedResults () {
        const from = (this.currentPage - 1) * this.productsPerPage
        let to = from + this.productsPerPage
        if (!this.compactView) {
          to = this.visibleProducts.length
        }
        return this.visibleProducts ? this.visibleProducts.slice(from, to) : []
      }
    }),
    plpCallout () {
      return (this.plpCalloutJson || []).filter(item => Number(item.id) === Number(this.collection.id))
    },
    blockSettings () {
      const collectionHandle = this.collection.handle.replace('/collections/', '')
      if (this.settings) {
        const blocksSettings = this.settings.hasOwnProperty('blocks') ? this.settings.blocks : []
        return blocksSettings.find(item => item.collection === collectionHandle)
      }
    },
    totalResults () {
      return this.visibleProducts.length
    }
  },
  methods: {
    bannerImageSources(product) {
      const images = []
      if (product.imageMobile) images.push(product.imageMobile)
      if (product.imageDesktop) images.push(product.imageDesktop)
      return images.join('|')
    },
    bundleImageSources(product) {
      const images = []
      if (product.imageMobile) images.push(product.imageMobile)
      if (product.imageDesktop) images.push(product.imageDesktop)
      return images.join('|')
    },
    shouldShowProduct (product) {
      const productFacetMatches = this.selectedFacets.reduce((obj, facet) => {
        if (typeof obj.needed === 'undefined') {
          obj.needed = {}
        }
        if (typeof obj.matches === 'undefined') {
          obj.matches = {}
        }
        obj.needed[facet.name] = true
        if (
          typeof product[facet.name] !== 'undefined' &&
          ~product[facet.name].indexOf(facet.value)
        ) {
          obj.matches[facet.name] = true
        }
        return obj
      }, {})

      if (!productFacetMatches.needed) {
        return true
      }

      return Object.keys(productFacetMatches.needed).every(key => {
        return typeof productFacetMatches.matches[key] !== 'undefined'
      })
    },
    fetchCollectionHeroSettings () {
      const heroSettingsEl = this.$refs['plp-hero-settings']
      if (heroSettingsEl) {
        const settings = heroSettingsEl.getAttribute('data-settings')
        const decodedSettings = decodeURIComponent(settings)
        this.settings = JSON.parse(decodedSettings)
      }
    },
    getCollectionSetting (name) {
      if (this.blockSettings) {
        return this.blockSettings[name]
      } else if (this.settings) {
        return this.settings[name]
      }
    },
    handleChangePagination (event) {
      this.setCurrentPage(event)
      this.$nextTick(function () {
        window.scrollTo({
          top: this.$refs['plp-wrap'] ? this.$refs['plp-wrap'].offsetTop : 0,
          behavior: 'smooth'
        })
      })
    },
    ...mapActions([
      'setCurrentPage',
      'fetchCollection',
      'toggleFilterMenu',
      'toggleCompactView',
      'resetSelectedFacets'
    ])
  }
})
